import { QueryClient } from '@tanstack/react-query';

const millisecondsInAMinute = 1000 * 60;
const millisecondsInAnHour = millisecondsInAMinute * 60;

// Shared singleton so that non-React code (eg ApiBase) can write to the cache,
// not just hooks via useQueryClient.
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			refetchOnReconnect: false
		}
	}
});

// All query caching time
export const staleTimeInADay = millisecondsInAnHour * 24; // Longest for never change data, eg BBOC questions data
export const staleTimeForSession = millisecondsInAnHour * 24 * 7; // Default for data that only client can change - Refresh token (session) lasts 7 days, sliding on each refresh
export const staleTimeInTwoHours = millisecondsInAnHour * 2; // Default long for data that Partner can change in SPOT
export const staleTimeInOneHour = millisecondsInAnHour;
export const staleTimeInFifteenMinutes = millisecondsInAMinute * 15;
export const staleTimeInFiveMinutes = millisecondsInAMinute * 5; // Default short for data that Partner can change in SPOT
export const staleTimeInOneMinute = millisecondsInAMinute; // Shortest for data needs refresh immediately, eg health steps

// Query caching time for special use cases
export const staleTimeForAzureFileSasToken = millisecondsInAMinute * 10; // Cache Sas Url for 10 minutes which should be less than the Sas token expiry 15 minutes (PrivateFileLinkSasTokenExpirationInMinutes).
export const staleTimeForAzureMediaFileSasToken = millisecondsInAnHour * 1; // 1 hour cache for video file sas url and is less than the backend expiry of 1.5 hours (90 mins) (AzureMediaFileSasTokenExpirationInMinutes) to avoid user experience issue due to expired sas token when watching video for a long time.

// Should define query keys here if they are used in multiple places
export const clientContextQueryKey = ['clients', 'context'];
export const clientProfileCompletionQueryKey = ['clients', 'profileCompletionPercentage'];
export const familyMembersQueryKey = ['clients', 'familyMembers'];

export const isSurveyEmailSentQueryKey = (surveyUniqueId: string) => ['surveys', surveyUniqueId, 'isEmailSent'];
export const surveysQueryKey = ['surveys'];
export const surveyAnswersQueryKey = (surveyUniqueId: string) => ['surveys', surveyUniqueId, 'surveyAnswers'];
export const surveyAnswerQueryKey = (surveyUniqueId: string, questionUniqueName: string) => [
	'surveys',
	surveyUniqueId,
	'surveyAnswers',
	questionUniqueName
];

export const versionCheckQueryKey = (platform: string, appName: string) => ['version', 'check', platform, appName];
